import React from 'react';
import SidebarUnitDesktop from 'components/sidebar/components/SidebarUnitDesktop';
import { DocumentIcon } from 'assets/icons';

const PayslipManagementDL = () => {
  return (
    <SidebarUnitDesktop
      routeName="Paie & Factures"
      routeSidebar="/payslipManagement/payslips"
      activePatterns={['/payslipManagement']}
      icon={DocumentIcon}
      text="Paie & Factures"
    />
  );
};

export default PayslipManagementDL;
